Ext.ns('mx.app.widget');

mx.app.widget.ExpandableGridPanel = Ext.extend(Ext.grid.GridPanel, {
    expandable: true,
    readOnly: false,
    readOnlyToolbar: null,
    headers: [],
    bbarButtons: [],
    checkColumns: true,
    border: false,
    layout: 'fit',
    addedNew: false,
    loadStoreOnStart: true,
    recordLoadDelay: 0,
    pageSizes: [15, 30, 60],
    pageSize: 30,
    bbarClass: mx.comp.PagingToolbar,
    viewConfig: {forceFit: true},
    refreshRowOnCollapse: true,
    cls: 'mx-widget-expandablegridpanel',
    highlightUpdateColor: 'FF0000',
    highlightReloadColor: '00FF00',
    rowNumUrl: null,

    updateRows: function() {
        if (this.store.baseParams.filterId) {
            this.store.reload();
        }
    },

    gridlabels: {
        loading: 'Loading...',
        deleteConfHeader: 'Warning',
        deleteConfirmation: 'Do you really want to delete %d row(s)?',
        deleteConfirmationDescritive: 'Delete %b from the list?',
        confirmTitle: 'Confirmation',
        doYouWantToLeave: 'Do you want to leave row editing without saving changes?',
    },
    editPanelSettings: {
        rolesForHistory: mx.app.widget.EditPanel.prototype.rolesForHistory, //["admin", "super_admin"]
    },
    getSelectedRecords: function() {
        var result = [];
        this.selModel.each(function(r) {
            result.push(r);
        });
    },

    pluralLabels: {
        Accounts: ['accounts', 'account'],
        AreasOfControl: ['areas of control', 'area of control'],
        Landmarks: ['landmarks', 'landmark'],
        Orders: ['orders', 'order'],
        RegionalDivisions: ['regional divisions', 'regional division'],
        Resources: ['resources', 'resource'],
        SalesChannel: ['sales channels', 'sales channel'],
        Users: ['users', 'user'],
    },

    handlePluralForms: function(word, count) {
        if (this.pluralLabels[word]) {
            if (count == 1) {
                word = this.pluralLabels[word][1];
            } else {
                word = this.pluralLabels[word][0];
            }
        }
        return word;
    },

    isFormReadonly: function(record) {
        return this.readOnly;
    },
    getRecordUrl: function(record) {
        return mx.PATH + record.store.url + record.getRecordId();
    },
    onExpandRow: function(expander, record, rowIndex) {
        Ext.ux.event.Broadcast.fireEvent('netactivityfreeze', true, 'expandable');
        this.getView().headersDisabled = true;

        this.setColumnModifiersLocked(true, rowIndex);
        var view = this.getView();
        view.el.mask(this.gridlabels.loading, 'x-mask-loading');

        expander.editPanel = new mx.app.widget.EditPanel(
            Ext.apply(
                {
                    checkIsDirty: !!this.viewConfig.collapseAfterSave,
                    formClass: this.form || this.getFormClass(),
                    isNew: !record.get(record.getIdKey()),
                    params: this.getParams(record, rowIndex),
                    readOnly: this.isFormReadonly(record),
                },
                this.editPanelSettings
            )
        );

        this.bottomToolbar.el.mask();

        expander.editPanel.on(
            'load',
            function(form) {
                if (record.store.appendable && record.getRecordId()) {
                    record.store.proxy.load(
                        null,
                        record.store.reader,
                        function(obj, options, success) {
                            if (success) {
                                if (obj.success) {
                                    record.data = obj.records[0].data;
                                    form.getForm().loadRecord(record);
                                    form.record = record;
                                    if (form.onRecordLoaded) {
                                        form.onRecordLoaded.call(form, record);
                                    }
                                } else {
                                    Ext.Msg.show({
                                        title: 'Error',
                                        msg: obj.errors
                                            .map(function(error) {
                                                return error.message;
                                            })
                                            .join('<br />'),
                                        icon: Ext.Msg.ERROR,
                                        buttons: Ext.Msg.OK,
                                    });
                                    this.store.reload();
                                }
                                view.el.unmask();
                            } else {
                                view.el.unmask();
                                this.getSelectionModel().deselectRow(rowIndex);
                            }
                        },
                        this,
                        null,
                        {
                            method: 'GET',
                            url: this.getRecordUrl(record),
                            params: this.getParamsToRequest(record),
                        }
                    );
                } else {
                    (function() {
                        form.getForm().loadRecord(record);
                        form.record = record;
                        //                    view.scrollToY(5000);
                        view.el.unmask();
                    }.defer(this.recordLoadDelay));
                }
            },
            this
        );

        expander.editPanel.on(
            'cancel',
            function(form) {
                this.addedNew = false;
                this.getSelectionModel().deselectRow(rowIndex);
                if (form.isNew) {
                    mx.data.Store.superclass.remove.call(record.store, record);
                }
                this.updateDeleteState();
            },
            this
        );

        expander.editPanel.on(
            'submit',
            function(form) {
                if (form.getAlerts && form.getAlerts()) {
                    Ext.Msg.confirm(
                        this.gridlabels.confirmTitle,
                        form.getAlerts(),
                        function(btn, text) {
                            if (btn == 'yes') {
                                this.addedNew = false;
                                form.getForm().updateRecord(record);
                            }
                        },
                        this
                    );
                } else {
                    this.addedNew = false;
                    form.getForm().updateRecord(record);
                }
            },
            this
        );

        var row = expander.grid.view.getRow(rowIndex);

        if (this.checkAllColumn) {
            expander.editPanel.wasChecked = record.data[this.checkAllColumn.dataIndex];

            if (!expander.editPanel.wasChecked) {
                this.checkAllColumn.checkByRowIndex(rowIndex);
            }
        }
        expander.editPanel.render(row);
        expander.editPanel.setWidth(this.view.cm.getTotalWidth());
    },
    updateDeleteState: function() {
        var toDelete = [];
        this.store.each(function(r) {
            if (r.get('selected')) {
                toDelete.push(r);
            }
        }, this);
        if (this.bottomToolbar.delButtonObj) {
            this.bottomToolbar.delButtonObj.setDisabled(toDelete.length == 0);
        }
        this.fireEvent('tickcheckbox', toDelete);
    },
    initComponent: function() {
        this.addEvents('tickcheckbox', 'storeloaded');

        this.store.baseParams = {};
        this.store.removeAll();
        var sc = this;

        this.on(
            'afterlayout',
            function() {
                this.store.on(
                    'beforeload',
                    function() {
                        this.el.mask(this.gridlabels.loading, 'x-mask-loading');
                        this.updateDeleteState.call(this);
                    },
                    this
                );
                this.store.on(
                    'load',
                    function() {
                        var store = this.store;
                        if (
                            this.getBottomToolbar() &&
                            this.getBottomToolbar().changePage &&
                            store.totalLength &&
                            store.lastOptions &&
                            store.lastOptions.params &&
                            store.lastOptions.params.startIndex
                        ) {
                            // check that page is still viable
                            if (store.lastOptions.params.startIndex >= store.totalLength) {
                                var start = 1;
                                if (store.lastOptions.params.results) {
                                    start = Math.floor(store.totalLength / store.lastOptions.params.results) + 1;
                                    this.getBottomToolbar().changePage(start);
                                    return;
                                }
                            }
                        }
                        this.fireEvent('storeloaded');
                        this.el.unmask();
                        this.bottomToolbar.el.unmask();
                        this.updateDeleteState.call(this);
                    },
                    this
                );
                if (this.loadStoreOnStart) {
                    this.store.load({params: {startIndex: 0, results: this.pageSize}});
                }
            },
            this,
            {
                single: true,
            }
        );

        this.readOnlyToolbar = this.readOnlyToolbar || this.readOnly;

        var bbar = (this.bbar = new this.bbarClass({
            pageSizes: this.pageSizes,
            pageSize: this.pageSize,
            readOnly: this.readOnlyToolbar,
            store: this.store,
            buttons: this.bbarButtons,
            buttonsClick: function(action) {
                if (action == 'add') {
                    this.addRecord(rowSelectionModel);
                }
                if (action == 'delete') {
                    var toDelete = [];
                    this.store.each(function(r) {
                        if (r.get('selected')) {
                            toDelete.push(r);
                        }
                    }, this);

                    if (!toDelete.length) return;

                    var toDeleteNames = [];
                    for (var i = 0; i < toDelete.length; i++) {
                        if (toDelete[i].data.name) {
                            toDeleteNames.push(toDelete[i].data.name);
                        }
                    }

                    Ext.Msg.confirm(
                        this.gridlabels.deleteConfHeader,
                        this.gridlabels.deleteConfirmationDescritive
                            .replace('%a', this.handlePluralForms(this.id, toDelete.length))
                            .replace('%b', toDeleteNames.join(', ')),
                        function(btn, text) {
                            if (btn == 'yes') {
                                sc.el.mask(sc.gridlabels.loading, 'x-mask-loading');
                                this.store.remove(toDelete, function() {
                                    sc.el.unmask();
                                });
                            }
                        },
                        this
                    );
                }
            }.createDelegate(
                this
            ) /*,
             listeners: {
             change: {
             fn: function() {
             this.checkAllColumn.uncheckHeader();
             },
             scope : this
             }
             }*/,
        }));

        if (this.checkColumns) {
            this.checkAllColumn = new mx.comp.CheckAllColumn(
                {
                    dataIndex: 'selected',
                    scope: this,
                },
                this.updateDeleteState
            );
        }

        var rowSelectionModel = new mx.comp.SingleRowSelectionModel({
            scope: this,
            fn: function(selectionModel, rowIndex, e) {
                var expander = selectionModel.grid.expander;
                var record = this.grid.store.getAt(rowIndex);
                if (expander.state[record.id]) {
                    if (!e.getTarget('.x-grid3-row-table')) return false;
                }
                if (expander.editPanel && expander.editPanel.form.getForm().isDirty() && !this.scope.addedNew) {
                    Ext.Msg.confirm(
                        this.scope.gridlabels.confirmTitle,
                        this.scope.gridlabels.doYouWantToLeave,
                        function(btn, text) {
                            if (btn == 'yes') {
                                expander.collapseRow(selectionModel.lastActive);
                                if (selectionModel.lastActive != rowIndex) {
                                    selectionModel.selectRow(rowIndex);
                                }
                            }
                        }.createDelegate(this)
                    );
                }
                return (
                    (!(expander.editPanel && expander.editPanel.form.getForm().isDirty()) && !this.scope.addedNew) ||
                    this.scope.readOnly
                );
            },
            listeners: {
                beforerowselect: function(selectionModel, rowIndex, e) {
                    return this.fn(selectionModel, rowIndex, e);
                },

                beforeMouseDown: function(selectionModel, rowIndex, e) {
                    return this.fn(selectionModel, rowIndex, e);
                },
            },
        });

        this.expander = new Ext.grid.RowExpander();

        this.expander.on(
            'beforeexpand',
            function(expander, record, body, rowIndex) {
                this.onExpandRow(expander, record, rowIndex);
            },
            this
        );

        this.expander.on(
            'beforecollapse',
            function(expander, record, body, rowIndex) {
                this.getView().headersDisabled = false;
                this.setColumnModifiersLocked(false, rowIndex);
                var content = expander.editPanel;

                this.bottomToolbar.el.unmask();

                if (content) {
                    if (this.checkAllColumn) {
                        if (!expander.editPanel.wasChecked && record.data[this.checkAllColumn.dataIndex]) {
                            this.checkAllColumn.checkByRowIndex(rowIndex);
                        }
                    }
                    content.destroy();
                    delete expander.editPanel;
                }
                Ext.ux.event.Broadcast.fireEvent('netactivityfreeze', false, 'expandable');
            },
            this
        );

        if (this.checkColumns) {
            this.colModel = new Ext.grid.ColumnModel([this.checkAllColumn].concat(this.headers));
        } else {
            this.colModel = new Ext.grid.ColumnModel(this.headers);
        }

        if (this.checkColumns) {
            if (this.plugins) {
                this.plugins.push(this.checkAllColumn);
            } else {
                this.plugins = [this.checkAllColumn];
            }
        }
        if (this.expandable) {
            this.selModel = rowSelectionModel;
            if (this.plugins) {
                this.plugins.push(this.expander);
            } else {
                this.plugins = [this.expander];
            }
        }

        rowSelectionModel.on(
            'rowselect',
            function(sm, rowIndex, record) {
                this.expander.expandRow(rowIndex);
            },
            this
        );

        rowSelectionModel.on(
            'rowdeselect',
            function(sm, rowIndex, record) {
                this.expander.collapseRow(rowIndex);
                if (this.refreshRowOnCollapse) {
                    this.view.refreshRow(record);
                }
            },
            this
        );

        mx.app.widget.ExpandableGridPanel.superclass.initComponent.apply(this, arguments);

        this.on(
            'resize',
            function() {
                if (this.expander.editPanel) {
                    this.expander.editPanel.setWidth(this.view.cm.getTotalWidth());
                }
            },
            this
        );
    },
    destroy: function() {
        Ext.destroy(this.expander.editPanel);
        Ext.destroy(this.expander);
        mx.app.widget.ExpandableGridPanel.superclass.destroy.call(this, arguments);
    },
    getView: function() {
        if (!this.view) {
            this.view = new mx.app.widget.ExpandableGridPanel.GridView(this.viewConfig);
        }
        return this.view;
    },
    setColumnModifiersLocked: function(isLock, rowIndex) {
        var gridView = this.getView();

        gridView.splitZone.locked = isLock;
        gridView.columnDrag.locked = isLock;
        gridView.columnDrop.locked = isLock;

        for (var id in gridView.cm.lookup) {
            var column = gridView.cm.lookup[id];
            if (column.toCommit) {
                Ext.fly(gridView.getCell(rowIndex, gridView.cm.findColumnIndex(column.dataIndex)))
                    .child('div')
                    [isLock ? 'mask' : 'unmask']();
            }
        }
    },
    /**
     * Может использоваться к примеру для закрытия формы редактирования перед применением нового фильтра
     *
     * @param callback - функция, вызываемая, если пользователь согласился закрыть панель редактирования.
     * Может содержать так же cancel-callback, который вызывается в случае отказа пользователя закрыть форму
     * (можно использовать для возврата параметров фильтра к предыдущим значениям):
     *  var callback = {
     *    success: function() {...},
     *    cancel : function() {...}
     *  }
     * @param scope
     */
    collapseEditpanelByOutterAction: function(callback, scope) {
        var successCallback = callback;
        var cancelCallback = Ext.emptyFn;

        if (callback.success) {
            successCallback = callback.success;
        }
        if (callback.cancel) {
            cancelCallback = callback.cancel;
        }

        if (this.expander.grid.getSelectionModel().selections.length > 0) {
            var ep = this.expander.editPanel;
            Ext.Msg.confirm(ep.labels.warning, this.gridlabels.doYouWantToLeave, function(btn, text) {
                if (btn == 'yes') {
                    ep.fireEvent('cancel', ep.form);
                    successCallback.call(scope || this);
                } else {
                    cancelCallback.call(scope || this);
                }
            });
        } else {
            successCallback.call(scope || this);
        }
    },
    hasExpanded: function(selectionModel) {
        var hasExpanded = false;
        var expandState = selectionModel.grid.expander.state;
        for (var i in expandState) {
            if (expandState[i] === true) {
                hasExpanded = true;
            }
        }
        return hasExpanded;
    },
    addRecord: function(selectionModel, data, useReader) {
        var hasExpanded = this.hasExpanded(selectionModel);
        if (!hasExpanded) {
            this.view.on(
                'rowsinserted',
                function(view, firstRow, lastRow) {
                    this.view.processRows(firstRow);
                    this.selModel.selectRow(firstRow, false);
                    this.getView()
                        .getRow(firstRow)
                        .scrollIntoView();
                },
                this,
                {single: true}
            );
            this.store.createRecord(data, useReader);
            var l = this.store.data.items.length;
            if (l == 1) {
                this.selModel.selectRow(0, false);
            }
            this.addedNew = true;
        }
    },
    getParams: Ext.emptyFn,
    getParamsToRequest: Ext.emptyFn,

    onReloadRecordObj: function(record) {
        if (!this.hasExpanded(this.getSelectionModel())) {
            if (record.get('author') == window.userId) {
                mx.data.SimpleRecord.newStore({
                    baseParams: this.store.baseParams,
                    url: MXAT.API(this.rowNumUrl + record.get('record').getRecordId()),
                }).load({
                    callback: function(r) {
                        var page = r[0].getRecordId();
                        this.store.on(
                            'load',
                            function() {
                                var index = this.store.findByValue('id', record.get('record').getRecordId());
                                if (index > -1) {
                                    var row = this.getView().getRow(index);
                                    row.scrollIntoView();
                                    Ext.fly(row).highlight(this.highlightReloadColor, {
                                        attr: 'background-color',
                                        easing: 'easeOut',
                                        duration: 2,
                                    });
                                }
                            },
                            this,
                            {single: true}
                        );
                        this.bottomToolbar.doLoad(parseInt(page));
                    },
                    scope: this,
                });
                eventManager.confirm(record.getRecordId());
            } else {
                this.store.reload({
                    callback: function() {
                        if (record.get('author') == window.userId) {
                            var index = this.store.findByValue('id', record.get('record').getRecordId());
                            if (index > -1) {
                                var row = this.getView().getRow(index);
                                row.scrollIntoView();
                                Ext.fly(row).highlight(this.highlightReloadColor, {
                                    attr: 'background-color',
                                    easing: 'easeOut',
                                    duration: 2,
                                });
                            }
                        }
                    },
                    scope: this,
                });
                eventManager.confirm(record.getRecordId());
            }
        }
    },

    onUpdateRecordObj: function(record) {
        var recordObj = record.get('record');
        if (
            this.getSelectionModel().getSelected() &&
            this.getSelectionModel()
                .getSelected()
                .get('id') == recordObj.getRecordId()
        ) {
            return;
        }
        var index = this.store.findByValue('id', recordObj.getRecordId());
        if (index > -1) {
            mx.data.Store.superclass.remove.call(this.store, this.store.getAt(index));
            this.store.insert(index, recordObj);
            if (record.get('author') == window.userId) {
                var row = this.getView().getRow(index);
                row.scrollIntoView();
                Ext.fly(row).highlight(this.highlightUpdateColor, {
                    attr: 'background-color',
                    easing: 'easeOut',
                    duration: 2,
                });
            }
            eventManager.confirm(record.getRecordId());
        } else {
            this.onReloadRecordObj.call(this, record);
        }
    },
});

mx.app.widget.ExpandableGridPanel.GridView = Ext.extend(Ext.grid.GridView, {
    collapseAfterSave: true,
    afterMove: function(colIndex) {
        for (var id in this.cm.lookup) {
            var column = this.cm.lookup[id];
            if (column.renderHeader) {
                column.renderHeader(this);
            }
        }
    },
    onUpdate: function(ds, record, operation) {
        if (operation == Ext.data.Record.EDIT) {
            Ext.fly(this.getRow(ds.indexOfId(record.id))).mask();
            return;
        }

        Ext.fly(this.getRow(ds.indexOfId(record.id))).unmask();

        if (operation == Ext.data.Record.COMMIT) {
            if (this.collapseAfterSave || (record.get('stopCollapse') !== undefined && !record.get('stopCollapse'))) {
                this.grid.getSelectionModel().clearSelections();
                mx.app.widget.ExpandableGridPanel.GridView.superclass.onUpdate.apply(this, arguments);
                this.grid.updateRows();
            } else {
                if (this.grid.expander.editPanel.form.updateForm) {
                    this.grid.expander.editPanel.form.updateForm.call(this.grid.expander.editPanel.form);
                }
            }
        }

        if (operation == Ext.data.Record.REJECT && this.grid.expander.editPanel) {
            this.grid.expander.editPanel.form.getForm().markInvalid(record.error);
        }
    },

    scrollToY: function(y) {
        this.scroller.dom.scrollTop = y;
        this.scroller.dom.scrollLeft = 0;
    },

    initState: function(config) {
        if (this.stateful) {
            mx.app.widget.ExpandableGridPanel.superclass.initState.call(this, config);
        }
    },
});
